import React, { useState } from "react";
import { i18n } from "../../private/languageSelector";
import { Input } from "../../../../_metronic/_partials/controls";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import * as companyActions from "../../../../_redux/company/companyActions";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";

function Loyalty() {
  const language = localStorage.getItem("language");
  const [isValueChanged, setIsValueChanged] = useState(false);
  const { companyForEdit } = useSelector((state) => ({
    companyForEdit: state.company.companyForEdit,
  }));
  const initLoyaltyState = {
    name: companyForEdit?.pointsPercentage ? `${companyForEdit?.pointsPercentage}%` : "0%",
  };
  const loyaltySchema = Yup.object().shape({
    name: Yup.string(),
  });

  const dispatch = useDispatch();
  return (
    <div className="table-width loyalty-container" style={{ borderRadius: "0.42rem", float: language === "arabic" ? "right" : "left" }}>
      <div>
        <Formik
          enableReinitialize={true}
          initialValues={initLoyaltyState}
          validationSchema={loyaltySchema}
          onSubmit={(values) => {
            if (isValueChanged && companyForEdit && companyForEdit?._id) {
              dispatch(companyActions.updateCompany({ _id: companyForEdit?._id, pointsPercentage: values.name })).then(() => {
                toast.success(i18n("Company.LoyltySuccessfullyEdited"));
              });
            }
          }}
        >
          {({ handleSubmit, values, setFieldValue, dirty }) => {
            if (dirty) {
              setIsValueChanged(true);
            } else {
              setIsValueChanged(false);
            }
            return (
              <div>
                <div
                  className={`d-flex justify-content-between align-items-center ${language === "arabic" ? "flex-row-reverse" : "flex-row"}`}
                  style={{ paddingLeft: "1rem", paddingRight: "1rem" }}
                >
                  <div className="loyalty-setting">{i18n("Company.LoyaltySettings")}</div>
                  <div className={`d-flex align-items-center gap-3 ${language === "arabic" ? "flex-row-reverse" : "flex-row"}`}>
                    <div
                      className="cancel-text"
                      onClick={() => setFieldValue("name", companyForEdit?.pointsPercentage ? companyForEdit?.pointsPercentage : "0%")}
                    >
                      {i18n("SubscriptionModals.CANCEL")}
                    </div>
                    <div className={`save-text ${isValueChanged ? "active" : "inactive"} `} onClick={handleSubmit}>
                      {i18n("UserProfile.SAVE")}
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    paddingLeft: "1rem",
                    paddingRight: "1rem",
                    paddingTop: "3rem",
                    paddingBottom: "3rem",
                    background: "white",
                    marginTop: "2rem",
                  }}
                >
                  <Form className="form form-label-right">
                    <div className={`form-group ${language === "arabic" ? "rtl" : "ltr"}`}>
                      <Field
                        name="name"
                        component={Input}
                        disabled={false}
                        label={i18n("Company.PointsEarningPercentage")}
                        placeholder={i18n("Company.PointsEarningPercentage")}
                        withFeedbackLabel={true}
                      />
                      <span className="muted-bottom-text">{i18n("Company.LoyaltyInfoText")} </span>
                    </div>
                  </Form>
                </div>
              </div>
            );
          }}
        </Formik>
      </div>
    </div>
  );
}

export default Loyalty;
